interface DiscountBadgeProps {
  percentage: number;
}

/**
 * Small pill showing a payment method discount percentage.
 * Rendered next to a payment method name when the event has an active discount.
 */
export function DiscountBadge({ percentage }: DiscountBadgeProps) {
  return (
    <span
      className="rounded-full bg-primary-110 px-2 py-0.5 font-semibold text-white"
      style={{ fontSize: 11 }}
    >
      -{percentage}%
    </span>
  );
}
